import React from 'react'
import { faListUl } from '@fortawesome/pro-regular-svg-icons'
import { BoxV4 } from '@labrav/react-components'
import { BOX_COLLAPSIBLE_STYLE_V2 } from '../SubscriptionDetail.styles'
import { renderSubscriptionDetailHeadingIcon } from './renderSubscriptionDetailHeadingIcon'
import { SectionWrapper } from '../../../../common/components/SectionWrapper/SectionWrapper'
import {
  DetailRow,
  DetailInfo,
} from '../../../../common/components/DetailRow/DetailRow'
import { SubscriptionDetailObject } from '../../../../modules/subscription/reducer'
import { ViewValueWithTruncate } from '@labrav/common'
import { TextWithCopyIcon } from '@labrav/common'
import { compactDisplayId } from '../utils/subscriptionDetailHelperImports'

interface BuyerDetailsSectionProps {
  subscriptionDetail: SubscriptionDetailObject
  offerDetailInfo: {
    companyName?: string
  }
  classes: any
  cloudType?: string
}

export const BuyerDetailsSection: React.FC<BuyerDetailsSectionProps> = ({
  subscriptionDetail,
  offerDetailInfo,
  classes,
  cloudType,
}) => {
  if (cloudType === 'GCP' && subscriptionDetail) {
    const buyerDetails = subscriptionDetail.buyerDetails
    if (!buyerDetails) return null
    return (
      <div className={classes.boxWrapper}>
        <BoxV4
          variant="small"
          headingVariant="small"
          heading="Buyer details"
          headingIcon={renderSubscriptionDetailHeadingIcon(classes)}
          collapsible
          collapsibleStyle={BOX_COLLAPSIBLE_STYLE_V2}
        >
          <div className={classes.buyerDetailsContent}>
            <DetailRow borderBottom props={{ spacing: 1 }}>
              <>
                <DetailInfo
                  title="Buyer name"
                  value={buyerDetails.buyerName || '-'}
                  keyName="buyerName"
                  className={classes.buyerDetailInfo}
                />
                <DetailInfo
                  title="Email ID"
                  value={buyerDetails.email || '-'}
                  keyName="emailId"
                  className={classes.buyerDetailInfo}
                />
              </>
            </DetailRow>
            <DetailRow borderBottom={false} props={{ spacing: 1 }}>
              <>
                <DetailInfo
                  title="Buyer billing account ID"
                  value={
                    buyerDetails.billingAccountId ? (
                      <TextWithCopyIcon
                        text={buyerDetails.billingAccountId}
                        displayText={compactDisplayId(
                          buyerDetails.billingAccountId
                        )}
                      />
                    ) : (
                      '-'
                    )
                  }
                  keyName="buyerBillingAccountId"
                  className={classes.buyerDetailInfo}
                />
                <DetailInfo
                  title="Phone number"
                  value={buyerDetails.phoneNumber || '-'}
                  keyName="phoneNumber"
                  className={classes.buyerDetailInfo}
                />
              </>
            </DetailRow>
          </div>
        </BoxV4>
      </div>
    )
  }

  return (
    <SectionWrapper heading="Buyer details" icon={faListUl}>
      <div className={classes.sectionContent}>
        <DetailRow borderBottom props={{ spacing: 1 }}>
          <>
            <DetailInfo
              title="Buyer name"
              value={offerDetailInfo?.companyName || '-'}
              keyName="buyerName"
            />
            <DetailInfo
              title="Email ID"
              value={subscriptionDetail?.buyerDetails?.email || '-'}
              keyName="emailId"
            />
          </>
        </DetailRow>
        <DetailRow borderBottom={false} props={{ spacing: 1 }}>
          <>
            <DetailInfo
              title="Buyer billing account ID"
              value={
                <ViewValueWithTruncate
                  value={
                    subscriptionDetail.subscription.cloudAccountId ||
                    subscriptionDetail.buyerDetails?.azureBuyerId
                  }
                  showIcon
                />
              }
              keyName="buyerBillingAccountId"
            />
          </>
        </DetailRow>
      </div>
    </SectionWrapper>
  )
}
